
import { Purchase } from "@/models/base";
import AppPurchaseInfoLedgers from "./PurchaseInfoLedgers.vue";
import AppPurchaseInfoLedgersMobile from "./PurchaseInfoLedgersMobile.vue";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import { printHumanFloat } from "@/utils/pretty-print";

export default FormLike.extend({
	props: {
		purchase: {
			type: Object as ()=>Purchase,
			required: true
		}
	},
	computed: {
		totalBooked():string {
			return printHumanFloat(this.purchase.getLedgersTotal());
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
	},
	components: {
		AppPurchaseInfoLedgers,
		AppPurchaseInfoLedgersMobile
	},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});
